import React from 'react'

import _isEmpty from 'lodash/isEmpty'
import { useSelector } from 'react-redux'
import {
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'

import configRoutes from 'config/routes'
import { Loading } from 'components/atoms/Loading'

function SwitchRouter() {
  const clients = useSelector((state) => state.clients)
  const serverName = useSelector((state) => state.servername)
  const user = useSelector((state) => state.user)

  const currentClient = _isEmpty(clients) ? null : clients?.find((client) => client.name === serverName)
  const role = currentClient?.role

  const privateRoutes = Object.values(configRoutes).filter((route) => !route.isPublic)
  const publicRoutes = Object.values(configRoutes).filter((route) => route.isPublic)

  return (
    <Routes>
      {publicRoutes.map(({ component: Component, path }) => (
        <Route
          key={path}
          path={path}
          element={(
            <React.Suspense fallback={<Loading />}>
              <Component />
            </React.Suspense>
            )}
        />
      ))}

      {privateRoutes.map(({ component: Component, path, requiredRoles }) => (
        <Route
          key={path}
          path={path}
          element={
              user ? (
                !requiredRoles?.length || requiredRoles?.includes(role) ? (
                  <React.Suspense fallback={<Loading />}>
                    <Component />
                  </React.Suspense>
                ) : (
                  <Navigate to={configRoutes.notFound.path} />
                )
              ) : (
                <Navigate to={configRoutes.login.path} />
              )
            }
        />
      ))}

      <Route element={<Navigate to={configRoutes.notFound.path} />} path='*' />
    </Routes>
  )
}

export default SwitchRouter
